import { t } from "@/i18n-js/instance";
import { isRedemptionEnded } from "@circle-react/helpers/paywallCouponHelpers";
import type { PaywallCouponRedemptionStatus } from "@circle-react/types/PaywallCouponRedemption";
import { StatusBadge } from "@circle-react-uikit/StatusBadge";

interface CouponStatusBadgeProps {
  redemptionStatus: PaywallCouponRedemptionStatus;
}

export const CouponStatusBadge = ({
  redemptionStatus,
}: CouponStatusBadgeProps) => {
  if (!isRedemptionEnded(redemptionStatus)) {
    return null;
  }

  return (
    <span className="pl-2">
      <StatusBadge variant="warning">
        {t("settings.paywalls_admin_dashboard.coupon.status.ended")}
      </StatusBadge>
    </span>
  );
};
